const InviteText = [
  'Stay Informed and Get Your Invite.',
  'Invest in your future (literally, creating an AcademME profile is a step towards earning money for your education).',
  'Help us make the student-education provider matching process work better for everyone.',
  'What do you have to lose – hours trying to find the “right” program?',
  'Join our mailing list, stay informed, and have first access to AcademME!'
]

export default InviteText



// WEBPACK FOOTER //
// src/text/invite-text.js